<template>
  <div class="guides-references-item">
    <div class="guides-references-item-head">
      <div :class="`guides-references-item-name${isEditMode ? ' active' : ''}`">{{currentName}}</div>
      <el-button size="small" @click="editItem()">Редактировать</el-button>
      <el-button type="danger" size="small" @click="openReportModal()">Удалить</el-button>
      <el-button
          size="small"
          @click="addFile()"
          v-if="(referenceItem.reference_id === 3 && !referenceItem.report_file.filename) || (referenceItem.reference_id === 8 && !referenceItem.report_file.filename)"
      >
        Добавить файл
      </el-button>
      <p
          v-if="(referenceItem.reference_id === 3 && referenceItem.report_file.filename) || (referenceItem.reference_id === 8 && referenceItem.report_file.filename)"
      >
        <a :href="referenceItem.report_file.link" target="_blank">{{referenceItem.report_file.filename}}</a>  <el-button size="small" @click="removeFile()">Удалить файл</el-button></p>
    </div>
    <div class="guides-references-name-edit" v-if="isEditMode">
      <label>
        <el-input v-model="referenceName" autocomplete="off" :disabled="saveReferenceNameInProgress"></el-input>
      </label>
      <el-button type="primary" @click="saveReferenceName()" class="guides-references-name-edit-send" :disabled="saveReferenceNameInProgress || referenceName === currentName">Изменить</el-button>
    </div>
    <div v-if="keywordListA.length > 0">
      <p>Ключи первого уровня: </p>
      <div class="guides-references-keywords">
        <div class="guides-references-keywords-item" v-for="item of keywordListA" :key="item.id">
            <span>{{item.keyword}}{{item.approximation !== '-1' ? ' (' + item.approximation + ')' : ''}}</span>
          <i class="el-icon-delete" @click="deleteKeyword(item.id)" v-if="isEditMode" ></i>
        </div>
      </div>
    </div>
    <div v-if="keywordListB.length > 0">
      <p>Ключи второго уровня: </p>
      <div class="guides-references-keywords">
        <div class="guides-references-keywords-item" v-for="item of keywordListB" :key="item.id">
            <span>{{item.keyword}}{{item.approximation !== '-1' ? ' (' + item.approximation + ')' : ''}}</span>
          <i class="el-icon-delete" @click="deleteKeyword(item.id)" v-if="isEditMode" ></i>
        </div>
      </div>
    </div>
    <div v-if="keywordListC.length > 0">
      <p>Ключи третьего уровня: </p>
      <div class="guides-references-keywords">
        <div class="guides-references-keywords-item" v-for="item of keywordListC" :key="item.id">
            <span>{{item.keyword}}{{item.approximation !== '-1' ? ' (' + item.approximation + ')' : ''}}</span>
          <i class="el-icon-delete" @click="deleteKeyword(item.id)" v-if="isEditMode" ></i>
        </div>
      </div>
    </div>
    <div v-if="stopWordList.length > 0">
      <p>Стоп слова: </p>
      <div class="guides-references-keywords stop">
        <div class="guides-references-keywords-item" v-for="item of stopWordList" :key="item.id">
          <span>{{item.keyword}}</span>
          <i class="el-icon-delete" @click="deleteKeyword(item.id)" v-if="isEditMode" ></i>
        </div>
      </div>
    </div>
    <div class="guides-references-keywords-edit" v-if="isEditMode">
      <div class="guides-references-keywords-edit-row">
        <label>
          <span>Ключевое слово</span>
          <el-input v-model="newKeyword" autocomplete="off" :disabled="saveKeywordInProgress"></el-input>
        </label>
         <label>
          <span>Расстояние</span>
          <el-input v-model="approximation" type="number" autocomplete="off" :disabled="saveKeywordInProgress" ></el-input>
        </label>
        <label>
          <span>Уровень</span>
          <select v-model="block" :disabled="saveKeywordInProgress" class="el-input__inner">
            <option disabled value="">Выберите один из вариантов</option>
            <option value="A">Ключ первого уровня</option>
            <option value="B">Ключ второго уровня</option>
            <option value="C">Ключ третьего уровня</option>
          </select>
        </label>
        <el-button type="primary" @click="addKeyword()" class="guides-references-keywords-edit-add" :disabled="saveKeywordInProgress">Добавить</el-button>
      </div>
      <div class="guides-references-keywords-edit-row">
        <label>
          <span>Стоп слово</span>
          <el-input v-model="newStopWord" autocomplete="off" :disabled="saveKeywordInProgress"></el-input>
        </label>
        <el-button type="primary" @click="addStopWord()" class="guides-references-keywords-edit-add" :disabled="saveKeywordInProgress">Добавить</el-button>
      </div>
      <div class="guides-references-keywords-edit-row">
        <input type="file" @change="onFileChange"/>
<!--        <el-button type="primary" @click="addFromFile()" class="guides-references-keywords-edit-add" :disabled="saveKeywordInProgress">Добавить</el-button>-->
      </div>
      <el-button size="small" @click="cancelEdit()" class="guides-references-keywords-edit-close">Закрыть</el-button>
    </div>
    <el-dialog title="Удаление" :visible.sync="modalReportVisible" width="380px">
      <p>Удалить ленту {{referenceItem.keyword}}?
      </p>

        <span slot="footer" class="dialog-footer dialog-footer--report">
          <el-button @click="deleteItem()">ОK</el-button>
          <el-button @click="modalReportVisible = false">Отмена</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  import readXlsxFile from 'read-excel-file'

  // api
  import {
    getReferenceGetItemKeywordsApi,
    getReferenceAddItemKeywordApi,
    getReferenceRemoveItemKeywordApi,
    getReferenceUpdateItemApi
  } from "../../../../api/references";

  export default {
    name: 'ReferenceItem',
    props: {
      referenceItem: {
        type: Object
      },
      activeEditItemId: {
        type: Number
      }
    },
    data() {
      return {
        keywordList: [],
        keywordListA: [],
        keywordListB: [],
        keywordListC: [],
        newKeyword: '',
        stopWordList: [],
        newStopWord: '',
        approximation: '',
        block: '',
        referenceName: '',
        currentName: '',
        isEditMode: false,
        saveKeywordInProgress: false,
        saveReferenceNameInProgress: false,
        modalReportVisible: false,
      };
    },
    methods: {
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
      addFile() {
        this.$emit("onAddFile", this.referenceItem.id);
      },
      removeFile() {
        this.$emit("onRemoveFile", this.referenceItem.id);
      },
      openReportModal() {
        this.modalReportVisible = true;
      },
      deleteItem() {
        this.modalReportVisible = false;
        this.$emit("onDeleteItem", this.referenceItem.id);
      },
      editItem() {
        this.$emit("onEditItem", this.referenceItem.id);
      },
      cancelEdit() {
        this.newKeyword = '';
        this.$emit("onCancelEditItem");
      },
      deleteKeyword(id) {
        getReferenceRemoveItemKeywordApi({ reference_item_keyword_id: id }).then(() => {
          this.loadKeywords();
        });
      },
      loadKeywords() {
        getReferenceGetItemKeywordsApi({ reference_item_id: this.referenceItem.id }).then((resp) => {
          this.keywordList = resp.data.filter(item => item.keyword !== '' && item.is_stop === '0');
          this.keywordListA = resp.data.filter(item => item.keyword !== '' && item.is_stop === '0' && item.block == 'A');
          this.keywordListB = resp.data.filter(item => item.keyword !== '' && item.is_stop === '0' && item.block == 'B');
          this.keywordListC = resp.data.filter(item => item.keyword !== '' && item.is_stop === '0' && item.block == 'C');
          this.stopWordList = resp.data.filter(item => item.keyword !== '' && item.is_stop === '1');
        });
      },
      saveReferenceName() {
        if (this.referenceName === '' || this.referenceName === this.referenceItem.keyword) {
          return
        }

        this.saveReferenceNameInProgress = false

        const params = {
          reference_id: this.referenceItem.reference_id,
          item_id: this.referenceItem.id,
          keyword: this.referenceName,
          group_id: this.referenceItem.group_id,
        }

        getReferenceUpdateItemApi(params).then(() => {
          this.currentName = this.referenceName
          this.saveReferenceNameInProgress = false
        })
      },
      addKeyword() {
        if (this.newKeyword === '') {
          return
        }

        this.saveKeywordInProgress = true;

        const params = {
          reference_item_id: this.referenceItem.id,
          keyword: this.newKeyword,
          is_stop: false,
          approximation: this.approximation !== '' ? parseInt(this.approximation) : -1,
          block: this.block
        }

        getReferenceAddItemKeywordApi(params).then(() => {
          this.newKeyword = '';
          this.approximation = '';
          this.block = '';
          this.saveKeywordInProgress = false;
          this.loadKeywords();
        });
      },
      addStopWord() {
        if (this.newStopWord === '') {
          return
        }

        this.saveKeywordInProgress = true;

        const params = {
          reference_item_id: this.referenceItem.id,
          keyword: this.newStopWord,
          is_stop: true
        }

        getReferenceAddItemKeywordApi(params).then(() => {
          this.newStopWord = '';
          this.saveKeywordInProgress = false;
          this.loadKeywords();
        });
      },
      onFileChange(event) {
        let xlsxfile = event.target.files ? event.target.files[0] : null;
        readXlsxFile(xlsxfile, { sheet: 'Ключевые слова' }).then((rows) => {
          for (const item of rows.slice(1)) {
            if (!item[0] || !item[1] || !item[2]) {
              return
            }

            this.saveKeywordInProgress = true;

            let block = ''

            if (item[2] === 'Ключ первого уровня') {
              block = 'A'
            }

            if (item[2] === 'Ключ второго уровня') {
              block = 'B'
            }

            if (item[2] === 'Ключ третьего уровня') {
              block = 'C'
            }

            const params = {
              reference_item_id: this.referenceItem.id,
              keyword: item[0],
              is_stop: false,
              approximation: item[1],
              block: block
            }

            getReferenceAddItemKeywordApi(params).then(() => {
              this.saveKeywordInProgress = false;
            });
          }
          this.loadKeywords();
        })
        readXlsxFile(xlsxfile, { sheet: 'Стоп-слова' }).then((rows) => {
          for (const item of rows.slice(1)) {
            if (!item[0]) {
              return
            }

            this.saveKeywordInProgress = true;

            const params = {
              reference_item_id: this.referenceItem.id,
              keyword: item[0],
              is_stop: true
            }

            getReferenceAddItemKeywordApi(params).then(() => {
              this.saveKeywordInProgress = false;
            });
          }
          this.loadKeywords();
        })
      }
    },
    watch: {
      activeEditItemId() {
        this.isEditMode = this.activeEditItemId === this.referenceItem.id;
      }
    },
    mounted() {
      this.loadKeywords()
    },
    beforeMount() {
      this.currentName = this.referenceItem.keyword
      this.referenceName = this.referenceItem.keyword
      this.loadKeywords()
    }
  };
</script>

<style>
  .guides-references-item {
    padding: 20px;
    border-bottom: 1px solid #eee;
  }
  .guides-references-item:first-child {
    border-top: 1px solid #eee;
  }
  .guides-references-item-head {
    display: flex;
    align-items: center;
  }
  .guides-references-item-head .el-button--small, .el-button--small.is-round {
    padding: 4px;
  }
  .guides-references-item-head a {
    margin: 0 10px;
    color: inherit;
    text-decoration: none;
  }
  .guides-references-item-head a:hover {
    color: #409EFF;
  }
  .guides-references-item-name {
    margin: 0 20px 0 0;
    font-weight: 600;
  }
  .guides-references-item-name.active {
    font-size: 16px;
    font-weight: 500;
  }
  .guides-references-keywords {
    display: flex;
    flex-wrap: wrap;
  }
  .guides-references-keywords-item {
    background-color: #eee;
    border-radius: 3px;
    padding: 3px 10px;
    margin: 2px 10px 0 0;
  }
  .guides-references-keywords-item i {
    margin-left: 6px;
    cursor: pointer;
  }
  .guides-references-keywords-edit {
    padding: 15px 0 20px;
  }
  .guides-references-keywords-edit-row {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;
  }
  .guides-references-keywords-edit-row label > span {
    display: block;
    margin-bottom: 4px;
  }
  .guides-references-keywords-edit-row label {
    width: 300px;
    margin-right: 10px;
  }
  .guides-references-keywords-edit-row input[type="number"] {
    padding-right: 0;
  }
  .guides-references-keywords-edit-close {
    margin-top: 10px;
  }
  .guides-references-keywords.stop .guides-references-keywords-item {
    background-color: rgb(248, 185, 185);
  }
  .guides-references-name-edit {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .guides-references-name-edit label > span {
    display: block;
    margin-bottom: 4px;
  }
  .guides-references-name-edit label {
    width: 300px;
    margin-right: 10px;
  }
  @media screen and (max-width: 480px) {
    .guides-references-keywords-edit-row {
      display: block;
    }
  }
</style>
